export const ItemTypes = {
    BLOCK: "block",
}